import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';

import SimpleModal from '../../SimpleModal';
import Button from '../../Button';
import { WARNING, OK, DR_WARNING } from '../../../constants/strings';
import { Text } from '../../Base';
import warningTextModal from '../../styles/warningTextModal';

const useStyles = makeStyles(() => warningTextModal);

const DRWarningModal = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <SimpleModal
      onClose={onClose}
      open={open}
      title={WARNING.toUpperCase()}
      actions={
        <>
          <Button minWidthZero onClick={onClose} className={classes.blueButton}>
            {OK}
          </Button>
        </>
      }
    >
      <Text className={classes.text}>{DR_WARNING}</Text>
    </SimpleModal>
  );
};

export default memo(DRWarningModal);
